(() => {
  function bindHeader(root = document) {
    const header = root.querySelector('.site-header');
    if (!header || header.dataset.navigationBound) return;
    const button = header.querySelector('.menu-toggle');
    const nav = header.querySelector('#main-nav');
    if (!button || !nav) return;
    header.dataset.navigationBound = 'true';
    const close = (restoreFocus = false) => {
      nav.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
      header.querySelectorAll('.reports-nav[open]').forEach(details => { details.open = false; });
      if (restoreFocus) button.focus();
    };
    button.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      button.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && header.contains(document.activeElement)) close(nav.classList.contains('open'));
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) close();
      else header.querySelectorAll('.reports-nav[open]').forEach(details => {
        if (!details.contains(event.target)) details.open = false;
      });
    });
    nav.addEventListener('click', event => {
      if (event.target.closest('a')) close();
    });
    window.matchMedia('(min-width: 1101px)').addEventListener('change', event => {
      if (event.matches) close();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindHeader());
  else bindHeader();
  document.addEventListener('shopify:section:load', event => bindHeader(event.target));
})();
